export default __webpack_public_path__ + "static/media/makeup.e53a4437.jpg";